import firebase from 'firebase/app';// rollup bundle issue with ESM import
import 'firebase/auth';
import 'firebase/firestore';
var firebaseConfig = {
    apiKey: "AIzaSyCoXgSTgVnXKz4PWtFZgEXcEAy6rHNEexE",
    authDomain: "test-cf288.firebaseapp.com",
    databaseURL: "https://test-cf288.firebaseio.com",
    projectId: "test-cf288",
    storageBucket: "test-cf288.appspot.com",
    messagingSenderId: "570550545819",
    appId: "1:570550545819:web:391683e6dc69f3c655053e",
    measurementId: "G-QYX58ZWXGF"
};

console.log(firebase)

firebase.initializeApp(firebaseConfig);

export const auth = firebase.auth();
export const googleProvider = new firebase.auth.GoogleAuthProvider();

export const db = firebase.firestore();